'use strict';
/**
 * @author Maxim Seredkin
 */
export default function () {
  return {
    restrict: 'A',
    template: require('../view/project-tab-common.html'),
    controller: [
      '$scope',
      '$utils',
      'PStatusRestService',
      '$uibModal',
      function ($scope, $utils, PStatusRestService, $modal) {
        'use strict';
        $scope.openPlaceAddressOnYandexMaps = openPlaceAddressOnYandexMaps;
        $scope.getMaxProfitForeignWorkPlacesValue =
          getMaxProfitForeignWorkPlacesValue;
        $scope.changeStatus = changeStatus;

        $scope.isShowContractFields = isShowContractFields;

        $scope.teamOptions = ['<Все>', 'Инвестор', 'Координаторы', 'ОИВ, ОМСУ'];
        $scope.teamFilter = $scope.teamOptions[0];
        PStatusRestService.get(null, (data) => {
          $scope.projectStatuses = data._embedded;
        });

        function getMaxProfitForeignWorkPlacesValue() {
          return $scope.project.profitPlanWplaces
            ? $scope.project.profitPlanWplaces
            : 0;
        }

        function openPlaceAddressOnYandexMaps(placeAddress) {
          $utils.searchOnYandexMaps(placeAddress);
        }

        function changeStatus() {
          $modal
            .open({
              template: require('../module/progress/view/project-status-modal-change.html'),
              controller: 'ProjectStatusModalChangeController',
              size: 'md',
              backdrop: false,
              resolve: {
                status: function () {
                  return $scope.project.projectStatus != null
                    ? $scope.project.projectStatus
                    : { transitionDate: new Date() };
                },
                pStatuses: function () {
                  return angular.copy($scope.projectStatuses);
                },
              },
            })
            .result.then(function (data) {
              $scope.project.projectStatus = data;
            });
        }

        function isShowContractFields() {
          return (
            $scope.project.isGCHP || $scope.project.isMCHP || $scope.project.isConcession || $scope.project.isThirdPart
          );
        }
      },
    ],
  };
}
